import { isTypeAStandard } from './standardKinds'

type StandardWithTypeAndAcceptance = {
  id: string
  type: string
  isAccepted: boolean | null
}

export function canRejectTypeAStandard(
  standards: StandardWithTypeAndAcceptance[],
  standardId: string
): boolean {
  const standard = standards.find((row) => row.id === standardId)
  if (standard == null || !isTypeAStandard(standard.type)) {
    return true
  }

  const nonRejectedTypeA = standards.filter(
    (row) => isTypeAStandard(row.type) && row.isAccepted !== false
  )
  return nonRejectedTypeA.length > 1
}

export function getLockedTypeAIds(
  standards: Array<{ id: string; type: string }>,
  selectedIds: Set<string>
): Set<string> {
  const selectedTypeAIds = standards
    .filter((row) => isTypeAStandard(row.type) && selectedIds.has(row.id))
    .map((row) => row.id)

  if (selectedTypeAIds.length !== 1) {
    return new Set()
  }

  return new Set(selectedTypeAIds)
}

export function getRetainedTypeAIdsOnDeselectAll(
  standards: Array<{ id: string; type: string }>,
  selectedIds: Set<string>
): Set<string> {
  const typeAStandards = standards.filter((row) => isTypeAStandard(row.type))
  if (typeAStandards.length === 0) {
    return new Set()
  }

  const selectedTypeA = typeAStandards.filter((row) => selectedIds.has(row.id))
  const typeAToRetain = selectedTypeA[0] ?? typeAStandards[0]
  return new Set([typeAToRetain.id])
}
